// export const MAIN_API = "https://nicol-backend.zakirabd.com/public/api";
// export const  MAIN_API = "http://127.0.0.1:8000/api";
export const  MAIN_API = "https://api-db.nicode.az/public/api";

